// removed by extract-text-webpack-plugin
module.exports = {"menuText":"#4d4d4d","menuActiveText":"#4185EF","subMenuActiveText":"#4185EF","menuBg":"#fff","menuHover":"#f5f6fa","subMenuBg":"#fff","subMenuHover":"#f5f6fa","sideBarWidth":"200px"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/index.scss
// module id = yh13
// module chunks = 9